import { queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarColumnasPersonalizadas,
  listarPredefinidos,
  listarTemplates,
  listarTrabajos,
  obtenerCatalogo,
  obtenerRelaciones,
} from "../services/reporteria.api";

/** Catálogo (whitelist) · se pide UNA vez · staleTime alto (§5.2). */
export const catalogoQueryOptions = () =>
  queryOptions({
    queryKey: qk.repCatalogo,
    queryFn: obtenerCatalogo,
    staleTime: 10 * 60_000,
    retry: false, // 403 (sin acceso a reportería) no se reintenta
  });

export const relacionesQueryOptions = () =>
  queryOptions({
    queryKey: qk.repRelaciones,
    queryFn: obtenerRelaciones,
    staleTime: 10 * 60_000,
    retry: false,
  });

export function useCatalogo() {
  return useQuery(catalogoQueryOptions());
}
export function useRelaciones() {
  return useQuery(relacionesQueryOptions());
}

export function useTemplates() {
  return useQuery({ queryKey: qk.repTemplates, queryFn: listarTemplates });
}

export function useColumnasPersonalizadas() {
  return useQuery({ queryKey: qk.repColumnas, queryFn: listarColumnasPersonalizadas });
}

export function usePredefinidos() {
  return useQuery({ queryKey: qk.repPredefinidos, queryFn: listarPredefinidos });
}

/** "Mis reportes generados" · polling cada 15 s para reflejar el avance del job (§5.2). */
export function useTrabajos() {
  return useQuery({
    queryKey: qk.repTrabajos,
    queryFn: () => listarTrabajos(1, 15),
    refetchInterval: 15_000,
  });
}
